import React from 'react';
import { ApartmentsFilterMode, ApartmentsFilterState } from '../../hooks/useApartmentsFilter';
import '../common/Common.css';

interface Props {
  filter: ApartmentsFilterState;
  onModeChange: (mode: ApartmentsFilterMode) => void;
  onQueryChange: (q: string) => void;
  onReset: () => void;
}

const PLACEHOLDER: Record<ApartmentsFilterMode, string> = {
  name: '장소명 입력 (부분 일치)',
  address: '주소 입력 (부분 일치)',
};

const ApartmentsFilterBar: React.FC<Props> = ({ filter, onModeChange, onQueryChange, onReset }) => (
  <div className="filter-bar">
    <div className="segmented" role="tablist" aria-label="검색 대상">
      <button
        role="tab"
        aria-selected={filter.mode === 'name'}
        className={`segmented__btn ${filter.mode === 'name' ? 'segmented__btn--active' : ''}`}
        onClick={() => onModeChange('name')}
      >
        장소명
      </button>
      <button
        role="tab"
        aria-selected={filter.mode === 'address'}
        className={`segmented__btn ${filter.mode === 'address' ? 'segmented__btn--active' : ''}`}
        onClick={() => onModeChange('address')}
      >
        주소
      </button>
    </div>
    <input
      type="text"
      className="filter-bar__input"
      placeholder={PLACEHOLDER[filter.mode]}
      value={filter.query}
      onChange={e => onQueryChange(e.target.value)}
      aria-label={`${filter.mode === 'name' ? '장소명' : '주소'} 검색`}
    />
    <button className="btn btn--secondary btn--sm" onClick={onReset}>초기화</button>
  </div>
);

export default ApartmentsFilterBar;
